import { setDisplayErrorSnackBar } from "../features/userSlice";
import store from "../store";
import { postAnalyticsTracking } from "../logic/actionTracking/trackingHelper";
import { getLastLocation } from "./ReferrerTracker";

export const handleTracingUserClick = async (event: any) => {
  try {
    const trackedElement = event.target.closest("[data-tracker]");
    if (trackedElement) {
      const location = getLastLocation();
      let from;
      if (location?.pathname) {
        from = window.location.origin + location?.pathname + location?.search;
      } else {
        from = window.location.origin;
      }
      const to = window.location.href;
      const oauthTokenHeader = store.getState().user.userToken as string;
      const data = {
        origin_path: from,
        target_path: to,
        action_id: trackedElement.getAttribute("data-tracker"),
      };
      postAnalyticsTracking(data, oauthTokenHeader);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
};
